<template>
  <div class="image">
    <van-image
      :fit="vars.imageFit"
      :width="vars.imageWidth"
      :height="vars.imageHeight"
      :lazy-load="vars.imageLazyload"
      :src="vars.imageSrc"
      @click="click"
    >
      <template v-slot:loading>
        <image-loading />
      </template>
      <template v-slot:error>
        <image-load-error />
      </template>
    </van-image>
  </div>
</template>

<script>
import Vue from 'vue';
import { Image, Lazyload } from 'vant';
import ImageLoading from '@/components/ImageLoading';
import ImageLoadError from '@/components/ImageLoadError';

Vue.use(Lazyload);

export default {
  name: 'ModuleImage',
  props: {
    vars: { type: Object, required: true },
  },
  components: {
    VanImage: Image,
    ImageLoading,
    ImageLoadError,
  },
  computed: {},
  methods: {
    click() {
      this.$emit('click', this.imageSrc);
    },
  },
};
</script>

<style lang="scss" scoped>
.error-placeholder {
  img {
    width: 100px;
  }
}
.image {
  font-size: 0;
}
</style>
